import { isArray } from "lodash";
import request, { env } from "../utils/request";

const ENV_MAP = {
  dev: "staging",
  fat: "staging",
  stage: "staging",
  prod: "production",
};

/**
 * https://yapi.gaoding.com/project/1536/interface/api/123990
 *  */
export async function getAds({ positions, variables, headers, ...query }) {
  try {
    const result = await request({
      method: "post",
      url: "/ads",
      ignoreMessage: true,
      ignoreError: true,
      timeout: 2000,
      data: {
        positions,
        variables: {
          env: [ENV_MAP[env]],
          ...variables,
        },
        ...query,
      },
      ...(headers
        ? {
            headers,
          }
        : null),
    });

    return isArray(result) ? result : [];
  } catch (e) {
    // console.info(e);

    return [];
  }
}
